const storage = {};

export default storage;
